import { ssoCodeExchange } from '@constants/endpoints';
import { AuthApisPayloads } from '@utils/types';
import { axiosInstance, ssoAxiosInstance } from '.';

export const sendOtpApi = async (
  data: Pick<AuthApisPayloads, 'phoneNo'>,
): Promise<boolean> => {
  const res = await axiosInstance.post('/v1/auth/send-otp', data);
  return !!res.data;
};

export const verifyOtpApi = async (
  verifyOtpApiPayload: AuthApisPayloads,
): Promise<string> => {
  const { data: verifyOtpData } = await axiosInstance.post(
    '/v1/auth/verify-otp',
    verifyOtpApiPayload,
  );

  return verifyOtpData?.data?.token;
};

export const generateNewTokenApi = async (
  loungeId: string,
): Promise<string> => {
  const { data } = await axiosInstance.post('/v1/auth/regenerate-token', {
    loungeId,
  });

  return data.data?.token;
};

export const exchangeSsoCodeApi = async (code: string): Promise<string> => {
  // The SSO code-exchange route is not yet available on the poshvine sandbox
  // (development/staging), so those environments point it at devstack via
  // VITE_SSO_EXCHANGE_URL, optionally pinned to a devstack instance with
  // VITE_SSO_EXCHANGE_DEV_SERVE_USER. Production leaves both unset and uses the
  // default self-check-in host — behaviour there is unchanged. Remove these
  // overrides once the backend consolidates SSO exchange onto the public
  // self-check-in routes.
  const exchangeUrl = process.env.VITE_SSO_EXCHANGE_URL || ssoCodeExchange;
  const devServeUser = process.env.VITE_SSO_EXCHANGE_DEV_SERVE_USER;
  const config = devServeUser
    ? { headers: { 'rzpctx-dev-serve-user': devServeUser } }
    : undefined;

  const { data } = await ssoAxiosInstance.post(exchangeUrl, { code }, config);

  return data.data?.token;
};
